import {Card} from '../../components/ui/Card';
import {useHistory, useParams} from 'react-router-dom';
import {useEffect, useState} from 'react';
import {API, graphqlOperation} from 'aws-amplify';
import {H1, H2, H3} from '../../components/ui/Header';
import {Form, FormButtons, FormContent, FormItem, FormPair} from '../../components/ui/Form';
import Button from '../../components/ui/Button';
import Flex from '../../components/ui/Flex';
import Container from '../../components/ui/Container';
import List from '../../components/ui/List';
import {createProductReview} from '../../graphql/mutations';

const initialFormState = {
  title: '', content: '', stars: 5
}

export default function ProductDetail() {
  const history = useHistory()
  const {sku} = useParams()
  const [product, setProduct] = useState()
  const [loadingProduct, setLoadingProduct] = useState(true)
  const [reviews, setReviews] = useState([])
  const [formState, setFormState] = useState(initialFormState)

  useEffect(() => {
    const fetchProduct = async () => {
      const productData = await API.graphql(graphqlOperation(`query productBySku {
        productBySku(sku: "${sku}") {
          items {          
            id
            name
            description
            image
            price
            reviews {
              items {
                createdAt
                content
                title
                stars
              }
            }
          }
        }
      }`))
      if(productData.data.productBySku.items[0] === undefined) {
        history.push('/')
      }
      setProduct(productData.data.productBySku.items[0])

      return productData.data.productBySku.items[0].reviews.items
    }

    setLoadingProduct(true)
    fetchProduct()
      .then((productData) => {
        setLoadingProduct(false)
        console.log(productData)
        setReviews(productData)
      })

  }, [sku, history])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setReviews([...reviews, formState])
    await API.graphql(graphqlOperation(createProductReview,
      {input: {content: formState.content, title: formState.title, stars: formState.stars, productID: product.id}}))

  }

  function updateForm(event) {
    const newFormState = {
      ...formState, [event.target.name]: event.target.value
    }
    setFormState(newFormState)
  }

  if(loadingProduct) {
    return (
      <Card>
        <H1>Loading...</H1>
      </Card>
    )
  }

  return (
    <Card>
      <H1>{product.name}</H1>
      <Flex flexDirection='row'>
        <img style={{flex: 1, width: '50%'}} src={product.image} alt={product.name}/>
        <Container style={{flex: 1}}>${product.price}</Container>
      </Flex>
      <hr/>
      <H3>Reviews</H3>
      <List
        data={reviews}
        loading={loadingProduct}
        Comp={({item}) =>
          <Container>
            <p><strong>{item.title} {item.stars}</strong></p>
            <p>{item.content}</p>
          </Container>
        }
      />
      <Form onSubmit={handleSubmit}>
        <FormContent>
          <H2>Add Review</H2>
          <FormPair>
            <label>Title:</label>
            <input
              onChange={event => updateForm(event)}
              name='title'
            />
          </FormPair>
          <FormPair>
            <label>Stars:</label>
            <input
              onChange={event => updateForm(event)}
              name='stars'
            />
          </FormPair>
          <H3>Review:</H3>
          <FormItem>
            <textarea
              onChange={event => updateForm(event)}
              name='content'
            />
          </FormItem>
          <FormButtons>
            <Button>Submit Review</Button>
          </FormButtons>
        </FormContent>
      </Form>
    </Card>
  )
}